//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../Weld/Weld.StructureWeldBuilder.js";
import "../no/Section.js";
import "../Weld/Weld.CharacteristicsBuilder.js";
import "../no/LineColorFontWidthBuilder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/LineColorFontWidthBuilder.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[1,"Boundary",0,"Section",0],[1,"Characteristics",0,"Weld.CharacteristicsBuilder",0],[0,"Destination",1,0],[0,"DistanceTolerance",1,0],[1,"LineColorFontWidth",0,"LineColorFontWidthBuilder",0],[0,"NamePrefix",1,0],[1,"Panel",0,"ScCollector",0],[0,"ProjectionDirection",0,"GeometricUtilities.ProjectionOptions",0],[1,"Thickness",0,"Expression",0],[1,"Width",0,"Expression",0]],[],[]];
SPLM.Weld.SurfaceWeldBuilder = class extends SPLM.Weld.StructureWeldBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.SurfaceWeldBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.SurfaceWeldBuilder.DestinationTypes = Object.freeze({
    "WorkPart" : "WorkPart", "NewComponent" : "NewComponent"});

export default SPLM;